module.exports = __webpack_public_path__ + "static/media/TipoDoc6.3446872c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadTipoDoc/TipoDoc6.png
// module id = 2196
// module chunks = 0